import { module } from 'modujs';
import { transform } from '../utils/transform';
import { lerp } from '../utils/maths';
import { html } from '../utils/environment';
import config from '../config';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                closeButton: 'close'
            }
        }
    }

    init() {

        this.bindMousemove = this.mousemove.bind(this);
        window.addEventListener('mousemove',this.bindMousemove);

        this.bindResize = this.resize.bind(this);
        window.addEventListener('resize',this.bindResize);

        this.resize();

        this.$items = this.$('item');
        this.data = new Array();

        this.mouseY = 0;
        this.lerpedMouseY = 0;

        for (let i = 0; i < this.$items.length; i++) {
            const item = this.$items[i];

            this.data.push({
                el: item,
                offset: (item.getBoundingClientRect().top + (item.getBoundingClientRect().height/2)) / this.windowHeight
            });
        }
    }

    mousemove(e) {
        this.mouseY = e.clientY / this.windowHeight;
    }

    animate() {
        this.raf = requestAnimationFrame(() => this.animate());

        this.lerpedMouseY = lerp(this.lerpedMouseY, this.mouseY, 0.1);

        for (let i = 0; i < this.data.length; i++) {
            const offset = this.data[i].offset;

            const scale = Math.max(0.7,1 - (Math.abs(this.lerpedMouseY - offset)));
            const transformValue = `scale(${scale})`;
            transform(this.data[i].el, transformValue);

        }
    }

    resize() {
        this.windowHeight = window.innerHeight;

        if(this.data !== undefined) {
            for (let i = 0; i < this.data.length; i++) {
                const item = this.data[i].el;
                this.data[i].offset = (item.getBoundingClientRect().top + (item.getBoundingClientRect().height/2)) / this.windowHeight
            }
        }
    }

    open() {

        html.classList.add('has-menu-lang-open');

        if(this.timeout !== undefined) {
            clearTimeout(this.timeout);
        }
        
        this.timeout = setTimeout(() => {
            html.classList.remove('has-nav-open');

        }, 800)

        if(config.IS_MOBILE) return;
        this.animate();

       
    }

    close() {

        html.classList.add('has-menu-lang-open-is-closing');

        if(this.timeout !== undefined) {
            clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(() => {

            html.classList.remove('has-menu-lang-open');
            html.classList.remove('has-menu-lang-open-is-closing');

            if(config.IS_MOBILE) return;
            cancelAnimationFrame(this.raf);
            
        }, 600)

    }

    destroy() {

        if(!config.IS_MOBILE) return;
        cancelAnimationFrame(this.raf);
        window.removeEventListener('mousemove',this.bindMousemove);
        window.removeEventListener('resize',this.bindMousemove);

    }
}
